var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { getLocaleInputNumberFormat } from '../../../util';
import { useNumberInput } from './hooks';
export var NumberInput = function (_a) {
  var onChange = _a.onChange,
    min = _a.min,
    max = _a.max,
    decimal = _a.decimal,
    fixedDecimalScale = _a.fixedDecimalScale,
    _b = _a.fullWidth,
    fullWidth = _b === void 0 ? false : _b,
    props = __rest(_a, ["onChange", "min", "max", "decimal", "fixedDecimalScale", "fullWidth"]);
  var numericProps = useNumberInput(__assign({
    onChange: onChange,
    min: min,
    max: max,
    decimal: decimal,
    fixedDecimalScale: fixedDecimalScale
  }, props));
  return _jsx(NumericFormat, __assign({
    "data-testid": "inputnumber",
    customInput: TextField
  }, props, numericProps, getLocaleInputNumberFormat(), {
    fullWidth: fullWidth,
    sx: __assign({
      maxWidth: fullWidth ? 'unset' : '7rem'
    }, props.sx)
  }));
};